import i18n from '../../../../i18n'
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'url',
      label: 'Url',
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'version',
      label: i18n.t('common_words.version'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
  ];

  return { Table };
};

export default configTable;

